export default __webpack_public_path__ + "static/media/mh.0fba59c0.svg";